import { render } from "./x.vue?vue&type=template&id=5722b20e"
import script from "./x.vue?vue&type=script&lang=js"
export * from "./x.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__